import { useEffect, useState } from "react";
import mixpanel from "mixpanel-browser";
import * as Sentry from "@sentry/react";
import { Outlet, useLocation, useNavigate } from "react-router";

import { AppSidebar } from "@/components";
import { SIDEBAR_COOKIE_NAME, SidebarProvider } from "@/components/ui/sidebar";

import { useGetJobs } from "@/hooks/queries";
import { cookies } from "@/lib/cookies";
import { storage } from "@/lib/storage";
import { jobsStore } from "@/stores";

export const AppLayout = () => {
  // TODO: Should this logic be put in a separate provider/layer?
  const navigate = useNavigate();
  const [checkedAuth, setCheckedAuth] = useState(false);
  useEffect(() => {
    try {
      const user = storage.getUser();
      if (!user?.accessToken) {
        // TODO: Should we also call sign out here?
        storage.clear();
        void navigate("/sign-in");
      } else {
        try {
          // Identify the user in Mixpanel if they are signed in. This mirrors the implementation on the talent side.
          mixpanel.identify(user.id.toString());
          Sentry.setUser(user);
        } catch (error) {
          Sentry.captureException(
            `Error setting user on mixpanel or sentry: ${error as Error}`,
          );
        }
        setCheckedAuth(true);
      }
    } catch {
      // TODO: Should we also call sign out here?
      storage.clear();
      void navigate("/sign-in");
    }
  }, [navigate]);

  // Automatically scroll to top when navigating between routes.
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const setIsLoading = jobsStore((state) => state.setIsLoading);
  const setJobs = jobsStore((state) => state.setJobs);
  const { data: jobs } = useGetJobs({
    staleTime: Infinity,
  });
  useEffect(() => {
    if (jobs) {
      setIsLoading(false);
      setJobs(jobs);
    }
  }, [jobs, setIsLoading, setJobs]);

  const defaultOpen =
    // We only want the sidebar to be closed by default if the cookie value is
    // explicitly set to "false". Otherwise, we want the sidebar to be open by
    // default.
    cookies.get(SIDEBAR_COOKIE_NAME) === "false" ? false : true;

  if (!checkedAuth) {
    // TODO: Loading state.
    return null;
  }

  return (
    <SidebarProvider defaultOpen={defaultOpen}>
      <AppSidebar />
      <main className="w-full">
        <Outlet />
      </main>
    </SidebarProvider>
  );
};
